export default __webpack_public_path__ + "static/media/room_video.1f60c509.mp4";